import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, isRef as _isRef, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "b-hotels-travelers" }
const _hoisted_2 = {
  key: 0,
  class: "b-hotels-travelers__popup border-radius-sm"
}
const _hoisted_3 = { class: "b-hotels-travelers__popup_header border-bottom flex middle-xs" }
const _hoisted_4 = { class: "bold black fs-bigger-sm" }
const _hoisted_5 = { class: "b-hotels-travelers__popup_wrapper flex col" }
const _hoisted_6 = { class: "flex middle-xs between-xs" }
const _hoisted_7 = { class: "fs-bigger bold black" }
const _hoisted_8 = { class: "flex middle-xs between-xs" }
const _hoisted_9 = { class: "fs-bigger bold black" }
const _hoisted_10 = { class: "fs-general regular grey" }
const _hoisted_11 = { class: "b-hotels-travelers__label regular grey fs-general" }
const _hoisted_12 = { class: "b-hotels-travelers__info regular" }

import { computed, ComputedRef, PropType, ref, watch } from 'vue';
  import { useStore } from 'vuex';
  import { useI18n } from 'vue-i18n';
  import { Configurator } from '@/types';
  import ArrowBackIcon from '@/views/icons/ArrowBackIcon.vue';
  import GuestIcon from '@/views/icons/GuestIcon.vue';
  import AdultsCounterComponent from '../Flights/AdultsCounterComponent.vue';
  import BaseDropdownComponent from '@/views/components/Base/BaseDropdownComponent.vue';
  import ButtonComponent from '@/views/components/ButtonComponent.vue';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'HotelsTravelersPopupComponent',
  props: {
    adults: {
      type: Number,
      required: true,
    },
    children: {
      type: Array as PropType<Array<number>>,
      required: true,
    },
    fieldClassName: String,
  },
  emits: ["onChange", "setAdults", "setChildren"],
  setup(__props, { expose, emit }: { emit: ({
    (e: 'onChange'): void;
    (e: 'setAdults', value: number): void;
    (e: 'setChildren', value: number[]): void;
  }), expose: any, slots: any, attrs: any }) {

const props = __props

  const store = useStore();
  const { t } = useI18n();

  

  

  const childAgeRefs = ref<Array<InstanceType<typeof BaseDropdownComponent>>>(
    [],
  );
  const isPopupOpen = ref<boolean>(false);
  const configurator = ref<Configurator.State>(Configurator.builder());

  const isMobile: ComputedRef<boolean> = computed(
    () => store.state.support.isMobile,
  );

  const isSearchWithKidsEnabled = computed<boolean>(() => {
    return (
      configurator.value != null &&
      configurator.value.hotelModule.searchWithKids
    );
  });

  const travelers = computed(
    () =>
      adults.value + props.children.filter(it => typeof it === 'number').length,
  );
  const isSubmitEnabled = computed(() =>
    props.children.every(it => typeof it === 'number'),
  );
  const childrenAges = computed(() => [
    {
      text: t('searchForm.travelersPopup.newborns'),
      value: 0,
    },
    ...[...Array(17).keys()].map(it => ({
      text: it + 1,
      value: it + 1,
    })),
  ]);

  const adults = computed({
    get() {
      return props.adults;
    },
    set(value: number) {
      emit('setAdults', value);
    },
  });

  function removeChild() {
    emit('setChildren', props.children.slice(0, props.children.length - 1));
  }

  function addChild() {
    if (!Array.isArray(props.children)) {
      emit('setChildren', [null]);
      return;
    }

    emit('setChildren', [...props.children, null]);
  }

  function setChildAge(payload: { index: number; age: number }) {
    const { index, age } = payload;

    if (
      Array.isArray(props.children) &&
      index >= 0 &&
      index < props.children.length &&
      typeof age === 'number' &&
      age >= 0
    ) {
      emit(
        'setChildren',
        props.children.map((it, i) => (i === index ? age : it)),
      );
    }
  }

  function openPopup() {
    isPopupOpen.value = true;
  }

  function togglePopup() {
    isPopupOpen.value = !isPopupOpen.value;
  }

  function closePopup(e) {
    isPopupOpen.value = false;
  }

  function applyChanges() {
    isPopupOpen.value = false;
    emit('onChange');
  }

  watch(isPopupOpen, value => {
    if (!value) {
      emit('onChange');
    }
  });

  expose({
    isPopupOpen,
    openPopup,
  });

return (_ctx: any,_cache: any) => {
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass([
        'b-hotels-travelers__field',
        'flex',
        'middle-xs',
        __props.fieldClassName,
      ]),
      onClick: togglePopup,
      role: "button"
    }, [
      _createVNode(GuestIcon),
      _createElementVNode("span", null, _toDisplayString(_unref(isSearchWithKidsEnabled)
          ? _unref(t)('searchForm.travelersPopup.travelers', _unref(travelers))
          : _unref(t)('searchForm.travelersPopup.guests', _unref(travelers))), 1)
    ], 2),
    _createVNode(_Transition, {
      name: _unref(isMobile) ? 'fadeInUp' : 'dropdown'
    }, {
      default: _withCtx(() => [
        (isPopupOpen.value)
          ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
              _createElementVNode("div", _hoisted_3, [
                (_unref(isMobile))
                  ? (_openBlock(), _createBlock(ArrowBackIcon, {
                      key: 0,
                      fill: "black",
                      onClick: closePopup,
                      role: "button"
                    }))
                  : _createCommentVNode("", true),
                _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)('searchForm.travelersPopup.header')), 1)
              ]),
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", null, [
                      _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('searchForm.travelersPopup.adults')), 1)
                    ]),
                    _createVNode(AdultsCounterComponent, {
                      min: 1,
                      max: 4,
                      modelValue: _unref(adults),
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(adults) ? (adults).value = $event : null))
                    }, null, 8, ["modelValue"])
                  ])
                ]),
                (_unref(isSearchWithKidsEnabled))
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createElementVNode("div", null, [
                        _createElementVNode("div", _hoisted_8, [
                          _createElementVNode("div", null, [
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_unref(t)('searchForm.travelersPopup.children.title')), 1),
                            _createElementVNode("p", _hoisted_10, _toDisplayString(_unref(t)('searchForm.travelersPopup.children.subtitle')), 1)
                          ]),
                          _createVNode(AdultsCounterComponent, {
                            min: 0,
                            max: 4,
                            modelValue: __props.children.length,
                            onOnDecrement: removeChild,
                            onOnIncrement: addChild
                          }, null, 8, ["modelValue"])
                        ])
                      ]),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.children.length, (n) => {
                        return (_openBlock(), _createElementBlock("div", null, [
                          _createElementVNode("span", _hoisted_11, _toDisplayString(_unref(t)('searchForm.travelersPopup.ageOfChildLabel', { number: n })), 1),
                          _createVNode(BaseDropdownComponent, {
                            ref_for: true,
                            ref_key: "childAgeRefs",
                            ref: childAgeRefs,
                            modelValue: 
                  _unref(childrenAges).find(it => it.value === __props.children[n - 1])
                ,
                            options: _unref(childrenAges),
                            "onUpdate:modelValue": (age) => setChildAge({index: n - 1, age: (age as any).value}),
                            placeholder: 
                  _unref(t)('searchForm.travelersPopup.ageOfChildPlaceholder')
                
                          }, null, 8, ["modelValue", "options", "onUpdate:modelValue", "placeholder"])
                        ]))
                      }), 256)),
                      _createElementVNode("div", null, [
                        _createElementVNode("p", _hoisted_12, _toDisplayString(_unref(t)('searchForm.travelersPopup.ageLimitsInfo')), 1)
                      ])
                    ], 64))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createVNode(ButtonComponent, {
                    variant: "primary",
                    fullWidth: "",
                    enable: _unref(isSubmitEnabled),
                    onClick: applyChanges
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)('searchForm.travelersPopup.apply')), 1)
                    ]),
                    _: 1
                  }, 8, ["enable"])
                ])
              ])
            ])), [
              [_directive_click_outside, closePopup]
            ])
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["name"])
  ]))
}
}

})